import { current } from "@reduxjs/toolkit";
import React from "react";
import { useDispatch } from "react-redux";

const Counter = ({ count, max, min,currentInd,type,callFunc }) => { 
  
  return (
    <>
      <div className="d-flex align-items-center ">
        <button
          onClick={() => count > min && callFunc(currentInd,type,'dec')}
          type="button"
          className="button-minus border rounded-circle  icon-shape icon-sm mx-1"
        >
          <img src="assets/images/minus-icon.svg" />
        </button>
        <input
          className="quantity-field border-0 text-center w-25"
          type="text"
          value={count}
          readOnly      
        />
        <button
          type="button"
          onClick={() => count < max && callFunc(currentInd,type,'inc')}
          className="button-plus border rounded-circle  icon-shape icon-sm mx-1"
        >
          <img src="assets/images/plus-icon.svg" />
        </button>
      </div>
    </>
  );
};

export default Counter;
